module.exports = __webpack_public_path__ + "static/media/ford-flights-map.00f73938.png";